<template>
  <div class="captcha-dialog" id="captcha-dialog" v-show="isCaptchaShow">
    <div
      class="captcha-dialog-container"
      v-show="isCaptchaShow"
      transition="captcha-dialog-zoom-in">
      <div class="img-box" @click="close">
        <img src="../../img/lottery/close.png">
      </div>
      <div class="verify-code-content">
        <h4>请输入短信验证码</h4>
        <p class="tips">短信验证码发送至{{formatMobile(phoneNum)}}</p>
        <input
          maxLength="6"
          pattern="\d*"
          type="tel"
          v-model="code"
          @keyup="handleChange(code,btns)"
        />
        <button
          id="captcha"
          class="count-text"
          @click="handleClick(btns)"
        >
          重发验证码
        </button>      
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dialog',
  props: ['title', 'btns','code', 'phoneNum'],
  data() {
    return {
      isCaptchaShow: false,
    }
  },
  methods: {
    open() {
      this.isCaptchaShow = true
    },
    close() {
      this.isCaptchaShow = false
    },
    handleChange(code, btns) {
      btns.onChange && btns.onChange(code)
    },
    handleClick(btns){
      btns.getCode && btns.getCode()
    },
    // 格式化电话号码
    formatMobile(data) {
      if (!data) {
        return null
      }
      let cardNum = /(\d{3})\d*(\d{4})/
      return data.replace(cardNum, '$1****$2')
    }
  }
}
</script>

<style lang="sass">
@import "../../sass/base/_abbrev.scss";

.captcha-dialog {
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  background-color: rgba(0, 0, 0, .55);
  font-family: PingFang SC-Regular,PingFang SC;

  &-container {
    box-sizing: border-box;
    z-index: 1000;
    width: 80%;
    max-height: 80%;
    font-size: rem(32);
    background-color: #fff;
    user-select: none;
    padding: rem(20);
    .img-box {
      text-align: right;
      img{
        display: inline;
        width: rem(32);
        height :rem(32);
      }
    }
    .verify-code-content {
      text-align: left;
      font-size: rem(26);
      position: relative;
      margin-bottom: rem(25);
      h4 {
        font-size: rem(28);
        font-weight: 400;
        color: #333333;
      }

      .tips {
        font-size: ren(24);
        font-weight: 400;
        color: #666666;
        margin: rem(20) 0 rem(20);
      }

      input {
        width: 90%;
        padding-left: rem(23);
        height: rem(100);
        background: #FFFFFF;
        border: 0;
        border-bottom: rem(2) solid #EDEDED;
      }
      .count-text,.count-text[disabled] {
        position: absolute;
        top: rem(120);
        right: rem(30);
        width: rem(190);
        height: rem(60);
        background: #1B89FE;
        color: #FFFFFF;
        border: 0;
        border-radius: rem(29);
        font-size: rem(24);
        &.disabled {
          background: #eae8e8;
        }
      }
      .count-text[disabled]{
        background: #eae8e8;
      }
    }
  }

  &-zoom-in-transition {
    opacity: 1;
    transition: all .5s ease;
  }

  &-zoom-in-enter,
  &-zoom-in-leave {
    opacity: 0;
    transform: scale3d(.3, .3, .3);
  }
}
</style>



// WEBPACK FOOTER //
// dialog.vue?4eff304a